module.exports = __webpack_public_path__ + "img/category-botany.0f5870e0.svg";